import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Answer } from './App';
import { parseISO } from 'date-fns/esm';



const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const getSavedAnswers = () => {
  const text = localStorage.getItem("answers")
  const retrievedAnswers = text !== null ? JSON.parse(text) : []

  const retrievedAnswersWithDateType: Answer[] = retrievedAnswers.map((a: any) => ({
    ...a,
    date: parseISO(a.date)
  }))

  return retrievedAnswersWithDateType
}
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<App savedAnswers={getSavedAnswers()} />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
